
import { useState } from "react";
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Department } from "./departmentData";

interface DepartmentListProps {
  departmentsByRegion: Record<string, Department[]>;
  activeRegion: string | null;
  onRegionClick: (region: string) => void;
}

const DepartmentList = ({ departmentsByRegion, activeRegion, onRegionClick }: DepartmentListProps) => {
  return (
    <div className="bg-gray-50 p-6 rounded-lg shadow border border-gray-100">
      <h3 className="text-xl font-heading font-bold mb-4 text-fabre-gray">
        Nos régions d'intervention
      </h3>
      
      {Object.keys(departmentsByRegion).map((region) => (
        <div key={region} className="mb-4">
          <button
            onClick={() => onRegionClick(region)}
            className={`flex items-center justify-between w-full p-3 rounded-md transition-colors ${
              activeRegion === region 
                ? "bg-fabre-green text-white" 
                : "bg-white text-fabre-gray hover:bg-fabre-lightgreen"
            }`}
          >
            <span className="font-medium">{region}</span>
            <span className="text-sm">
              {departmentsByRegion[region].length} départements
            </span>
          </button>
          
          {activeRegion === region && (
            <div className="mt-2 p-3 bg-white rounded-md border border-gray-100 shadow-sm">
              <p className="text-sm mb-2 text-gray-600">Départements desservis :</p>
              <div className="flex flex-wrap gap-2">
                {departmentsByRegion[region].map((dept) => (
                  <Link 
                    key={dept.code}
                    to={`/sites?dept=${dept.code}`}
                    className="px-2 py-1 bg-gray-100 hover:bg-gray-200 rounded text-sm"
                    title={`Services Groupe Fabre dans le ${dept.name} (${dept.code})`}
                  >
                    <span>{dept.code}</span> - <span>{dept.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}
          {region !== Object.keys(departmentsByRegion).pop() && <Separator className="my-4" />}
        </div>
      ))}
    </div>
  );
};

export default DepartmentList;
